'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useId, useState, type ReactNode } from 'react';

type FaqMoreProps = {
  showLabel: string;
  hideLabel: string;
  children: ReactNode;
};

export function FaqMore({ showLabel, hideLabel, children }: FaqMoreProps) {
  const [open, setOpen] = useState(false);
  const contentId = useId();

  return (
    <div className="mt-1 flex flex-col">
      <button
        type="button"
        aria-expanded={open}
        aria-controls={contentId}
        onClick={() => setOpen(value => !value)}
        className={cn(
          'inline-flex cursor-pointer items-center gap-2.5 self-start py-2.5 text-[.95rem] font-bold text-[#00a1e6]',
          open && 'order-2',
        )}
      >
        {open ? hideLabel : showLabel}
        <span
          aria-hidden
          className={cn(
            'flex items-center justify-center font-extrabold transition-transform duration-200',
            open && 'rotate-180',
          )}
        >
          ⌄
        </span>
      </button>
      <div id={contentId} hidden={!open}>
        {children}
      </div>
    </div>
  );
}
